import { combineReducers } from 'redux';
import selectedSubtype from './selected-subtype';
import skipTemplateView from './skip-template-view';
import amountTemplates from './amount-templates';

export interface TemplateState {
  selectedSubtype: string;
  skipTemplateView: boolean;
  amountTemplates: number;
}

export const getSubtype = (state: TemplateState): string => {
  if (!state) {
    return null;
  }
  return state.selectedSubtype || null;
};

export const shouldSkipTemplateView = (state: TemplateState): boolean => {
  if (!state) {
    return false;
  }

  if (!state.selectedSubtype) {
    // If no template has been selected we ignore the skip value,
    // so the user must select a template.
    return false;
  }

  return state.skipTemplateView;
};

export default combineReducers<TemplateState>({
  amountTemplates,
  selectedSubtype,
  skipTemplateView,
});
